import { useDate } from 'Globals/useDate'
import { ChartFrame } from 'components/ChartFrame'
import { global_locales, virus_colors, virusnames } from 'components/constants'
import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useWindowSize } from 'usehooks-ts'

const locales = global_locales.virussharetable

export const VirusShareTable = ({
  colorMode = 'light',
  lang = 'de',
}: {
  colorMode?: 'dark' | 'light' | undefined
  lang?: 'de' | 'fr'
}) => {
  const [data, setData] = useState<any[] | undefined>()
  const [hoveredColumn, setHoveredColumn] = useState<number | undefined>(0)
  const endDate = useDate()

  const windowSize = useWindowSize()
  const isMobile = windowSize.width < 712
  useEffect(() => {
    fetch(
      'https://storage.googleapis.com/ta-interaktiv/corona-dashboard-2023/chart_all_pathogens_share.json'
    )
      .then((a) => a.json())
      .then((a) => {
        setData(
          a.sort((a: any, b: any) => +new Date(b.date) - +new Date(a.date))
        )
      })
  }, [])

  return (
    <ChartFrame
      lang={lang}
      title={locales[lang].title}
      lead={locales[lang].lead}
      timestamp={
        <>
          {new Date(endDate).toLocaleDateString(lang + '-CH', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
          })}
        </>
      }
      source={locales[lang].source}
      colorMode={colorMode}
    >
      <VirusShareTableRoot>
        <Table>
          <Column>
            <Element className='date'>Rang</Element>
            <Element className='rank b'>
              <b>1.</b>
            </Element>
            <Element className='rank b'>
              <b>2.</b>
            </Element>
            <Element className='rank b'>
              <b>3.</b>
            </Element>
            {/* <Element className='rank'>4.</Element>
            <Element className='rank'>5.</Element>
            <Element className='rank'>6.</Element> */}
          </Column>
          {data &&
            data
              .slice(0, isMobile ? 4 : 11)
              .map((m: { [key: string]: number }, i: number) => (
                <Column
                  onMouseMove={() => setHoveredColumn(i)}
                  onTouchStart={() => setHoveredColumn(i)}
                  onMouseLeave={() => setHoveredColumn(0)}
                  style={{
                    flex: i === hoveredColumn ? '0 0 120px' : '0 0 55px',
                  }}
                >
                  <DateDisplay
                    style={{
                      borderRight:
                        i === hoveredColumn
                          ? '1px solid var(--site-background)'
                          : undefined,
                      borderLeft:
                        i === hoveredColumn
                          ? '1px solid var(--site-background)'
                          : undefined,
                      marginRight: i === hoveredColumn ? '4px' : '0px',
                      marginLeft:
                        i === hoveredColumn ? (i === 0 ? '0' : '4px') : '0px',
                      color:
                        i === hoveredColumn
                          ? colorMode === 'dark'
                            ? 'var(--beige-bright-3)'
                            : 'var(--brandblue-bright-1)'
                          : undefined,
                      backgroundColor:
                        i === hoveredColumn
                          ? colorMode === 'dark'
                            ? 'var(--beige-main)'
                            : 'var(--brandblue-bright-4)'
                          : undefined,
                    }}
                  >
                    {i === hoveredColumn && (
                      <>
                        {addDays('' + m.date, -2).toLocaleDateString(
                          lang + '-CH',
                          {
                            day: '2-digit',
                            // month: 'short',
                          }
                        )}
                        {'. '}
                        &mdash;{' '}
                        {addDays('' + m.enddate, 1).toLocaleDateString(
                          lang + '-CH',
                          {
                            day: '2-digit',
                            month: 'short',
                          }
                        )}
                      </>
                    )}
                  </DateDisplay>
                  {Object.entries(m)
                    .sort((a, b) => +b[1] - +a[1])
                    .map(([key, value], j) => {
                      if (key === 'date' || key === 'enddate') return
                      if(!value)console.log(key, value)
                      return (
                        <Element
                          style={{
                            // fontWeight: j < 5 ? 700 : 300,
                            backgroundColor: virus_colors[key],
                            marginRight: i === hoveredColumn ? '4px' : '0px',
                            marginLeft:
                              i === hoveredColumn
                                ? i === 0
                                  ? '0'
                                  : '4px'
                                : '0px',
                          }}
                        >
                          <Label>
                            {i === hoveredColumn ? virusnames[key][lang] : ''}
                          </Label>
                          <Value
                            style={{
                              fontWeight: i === hoveredColumn ? '700' : '300',
                              fontSize: i === hoveredColumn ? '14px' : '12px',
                            }}
                          >
                            {value
                              ?  (value as number).toFixed(1).toString().replace('.', ',')
                              : '0'}
                            {i == hoveredColumn ? '%' : ''}
                          </Value>
                        </Element>
                      )
                    })}
                </Column>
              ))}
        </Table>
      </VirusShareTableRoot>
    </ChartFrame>
  )
}

const VirusShareTableRoot = styled.div``

const Table = styled.div.attrs({ className: 'virus-share-table' })`
  display: flex;
  font-size: 14px;
  line-height: 1.4em;
  text-align: center;
  gap: 0px;
  max-width: calc(100vw - 30px);
  overflow: hidden;
`

const Column = styled.div`
  display: flex;
  flex-direction: column;
  &:hover {
    cursor: pointer;
  }
`

const Element = styled.div`
  border: 0.5px solid var(--site-background);
  user-select: none;
  padding-top: 5px;
  padding-bottom: 5px;
  height: 50px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  color: #202346;

  /* &.rank.b {
    font-size: 16px;
  } */
  &.rank {
    color: var(--text-color);
    width: 50px;
    border-bottom: 1px solid var(--sharetable-rank-border);
    &:last-of-type {
      border: 0;
    }
  }
  &.date {
    color: var(--text-color);
    padding-bottom: 6px;
    border-bottom: 1px solid var(--sharetable-rank-border);
  }
`

const Label = styled.div`
  flex: 0 0 100%;
  font-size: 13px;
  line-height: 1em;
`
const Value = styled.div`
  font-weight: 700;
  font-size: 13px;
  line-height: 1em;
`
const DateDisplay = styled.div`
  height: 40px;
  padding-top: 10px;
  padding-bottom: 5px;
  color: var(--text-color);
  display: flex;
  justify-content: center;
  align-items: center;
  /* color: var(--site-background);
  background-color: var(--text-color); */
`

function addDays(date: string, days: number) {
  var result = new Date(date)
  result.setDate(result.getDate() + days)
  return result
}
